import styled from 'styled-components';

import BaseInput from 'components/Input';

export const Input = styled(BaseInput)`
  @media ${({ theme }) => theme.device.desktop} {
    * > input {
      font-size: 18px;
      height: 60px;
    }
  }
`;
